<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="auctionRoutes"
          dense
          :disable-filtering="true"
          :disable-sort="true"
          :disable-pagination="true"
          :hide-default-footer="true">
          <template v-slot:item.routeTypeId="{ item }">
            {{ getTypeName(item.routeTypeId) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { showMessage, rules } from '../../../mixins'
import routeType from '../../../core/Auctions/routeType'
import { extractDateTime } from '../../../core/sharedFunctions'

export default {
  name: 'AuctionRoutes',
  mixins: [showMessage, rules],
  props: {
    routes: Array
  },
  data: () => ({
    auctionRouteSelected: {},
    auctionRoutes: [],
    isAddAuctionRouteDialogOpen: false
  }),
  computed: {
    headers () {
      const headers = [
        { text: this.$t('label.vendorCode'), value: 'vendorCode', align: 'center' },
        { text: this.$t('label.name'), value: 'vendorName', align: 'center' },
        { text: this.$t('label.address'), value: 'vendorAddress', align: 'center' },
        { text: this.$t('label.arriveAt'), value: 'arriveAt', align: 'center' },
        { text: this.$t('label.departAt'), value: 'departAt', align: 'center' },
        { text: this.$t('label.type'), value: 'routeTypeId', align: 'center' }
      ]
      return headers
    }
  },
  methods: {
    getTypeName (routeTypeId) {
      switch (routeTypeId) {
        case routeType.COLLECT:
          return this.$t(`routeType.${routeType.COLLECT}`)
        case routeType.DROP_OFF:
          return this.$t(`routeType.${routeType.DROP_OFF}`)
      }
    }
  },
  watch: {
    routes () {
      if (this.routes && this.routes.length > 0) {
        this.auctionRoutes = this.routes
        this.auctionRoutes = this.routes.map((r) => {
          if (r.arriveAt.toString().indexOf('T') > -1) {
            r.arriveAt = extractDateTime(r.arriveAt)
            r.departAt = extractDateTime(r.departAt)
            r.arriveAtDate = r.arriveAt.substring(0, 10)
            r.arriveAtTime = r.arriveAt.substring(11, 16)
            r.departAtDate = r.departAt.substring(0, 10)
            r.departAtTime = r.departAt.substring(11, 16)
          }
          return r
        })
      } else {
        this.auctionRoutes = []
      }
    }
  },
  mounted () {
    if (this.routes && this.routes.length > 0) {
      this.auctionRoutes = this.routes.map((r) => {
        r.arriveAt = extractDateTime(r.arriveAt)
        r.departAt = extractDateTime(r.departAt)
        return r
      })
    } else {
      this.auctionRoutes = []
    }
  }
}
</script>

<style>

</style>
